export enum ReducerKeys {
  AUTH_REDUCER = 'AuthReducer',
  TRANSL_REDUCER = 'TranslationReducer',
  NAVIGATION_REDUCER = 'NavigationReducer',
  MODAL_REDUCER = 'ModalReducer',
  THEME_REDUCER = 'ThemeReducer',
  COMMON_REDUCER = 'CommonReducer',
  RESET_PASSOWRD_REDUCER = 'ResetPasswordReducer',
  REGISTER_REDUCER = 'RegisterReducer',
  CHANGE_PASSWORD_REDUCER = 'ChangePasswordReducer',
  USER_PROFILE_REDUCER = 'UserProfileReducer',
  CLIENT_ACCOUNT_REDUCER = 'ClientAccountReducer',
  FORGOT_PASSWORD_REDUCER = 'ForgotPasswordReducer',
  PRODUCTS_REDUCER = 'ProductsReducer',
  PRODUCTS_REDUCER_MOBILE = 'ProductsReducerMobile',
  PRODUCT_REDUCER = 'ProductReducer',
  PROPERTY_BASICINFO_REDUCER = 'PropertyBasicInfoReducer',
  PROPERTY_AMENTITIES_REDUCER = 'PropertyAmentitiesReducer',
  HOST_REDUCER = 'HostReducer',
  PRODUCT_IMAGES_REDUCER = 'ProductImagesReducer',
  PRODUCT_FLOORPLANS_REDUCER = 'ProductFloorplansReducer',
  PRODUCT_DOCUMENTS_REDUCER = 'ProductDocumentsReducer',
  PROPERTY_LOCATION_REDUCER = 'PropertyLocationReducer',
  PRODUCT_NOTES_REDUCER = 'ProductNotesReducer',
  PRODUCT_ASSIGNED_TO_CLIENTS = 'ProductAssignedToClientsReducer',
  PRODUCT_MATCHED_CLIENTS = 'ProductMatchedClientsReducer',
  PRODUCT_MAIN_STORE_LISTINGS = 'ProductMainStoreListingsReducer',
  PRODUCT_APOINTMENT_AND_TASK = 'ProductApointmentAndTaskReducer',
  TASK_LIST_REDUCER = 'TaskListReducer',
  TASK_REDUCER = 'TaskReducer',
  APPOINTMENTS_REDUCER = 'AppointmentsReducer',
  CLIENT_LIST_REDUCER = 'ClientListReducer',
  CATEGORY_LIST_REDUCER = 'CategoryListReducer',
  CATEGORY_EDIT_REDUCER = 'CategoryEditReducer',
  TASK_BOARD_REDUCER = 'TaskBoardReducer',
  CLIENT_DETAILS_REDUCER = 'ClientDetailsReducer',
  PRODUCT_FILTER_REDUCER = 'ProductFilterReducer',
  CLIENT_NOTES_REDUCER = 'ClientNotesReducer',
  CLIENT_PUBLIC_NOTES_REDUCER = 'ClientPublicNotesReducer',
  CLIENT_DOCUMENTS_REDUCER = 'ClientDocumentsReducer',
  HOME_REDUCER = 'HomeReducer',
  PRODUCT_DETAILS_REDUCER = 'ProductDetailsReducer',
  PRODUCT_PRINT_PDF_REDUCER = 'ProductPrintPdfReducer',
  CLIENT_FAVORITES_REDUCER = 'ClientFavoritesReducer',
  CLIENT_SAVED_SEARCHES_REDUCER = 'ClientSavedSearchesReducer',
  SINGLE_CLIENT_SAVED_SEARCHES_REDUCER = 'SingleClientSavedSearchesReducer',
  SINGLE_CLIENT_REQUEST_REDUCER = 'SingleClientRequestReducer',
  SINGLE_CLIENT_LOCATION_REDUCER = 'SingleClientLocationReducer',
  CLIENT_COLLECTION_REDUCER = 'ClientCollectionReducer',
  CHAT_REDUCER = 'ChatReducer',
  CLIENT_TASK_REDUCER = 'ClientTaskReducer',
  TOPIC_REDUCER = 'TopicReducer',
  TOPIC_EDIT_REDUCER = 'TopicEditReducer',
  BLOGS_REDUCER = 'BlogsReducer',
  STORES_REDUCER = 'StoresReducer',
  BLOGS_SHOW_REDUCER = 'BlogsShowReducer',
  NEWS_SHOW_REDUCER = 'NewsShowReducer',
  BLOGS_SHOW_DETAIL_REDUCER = 'BlogsShowDetailReducer',
  NEWS_SHOW_DETAIL_REDUCER = 'NewsShowDetailReducer',
  TOPIC_SHOW_DETAIL_REDUCER = 'TopicShowDetailReducer',
  BLOG_EDIT_REDUCER = 'BlogEditReducer',
  STORES_EDIT_REDUCER = 'StoresEditReducer',
  SPECIFICATION_ATTRIBUTES_REDUCER = 'SpecificationAttributesReducer',
  SPECIFICATION_AMENITIES_REDUCER = 'SpecificationAmenitiesReducer',
  SPECIFICATION_CUSTOMER_REDUCER = 'SpecificationCustomerReducer',
  SPECIFICATION_ATTRIBUTE_EDIT_REDUCER = 'SpecificationAttributeEditReducer',
  NEWS_REDUCER = 'NewsReducer',
  NEW_EDIT_REDUCER = 'NewEditReducer',
  SETTINGS_GENERAL_REDUCER = 'SettingsGeneralReducer',
  SETTINGS_ADDITIONAL_REDUCER = 'SettingsAdditionalReducer',
  NEWS_LETTER_SUBSCRIPTION_REDUCER = 'NewsLetterSubscriptionReducer',
  CLIENT_CONVERSATIONS_REDUCER = 'ClientConversationsReducer',
  DOCUMENT_LIST_REDUCER = 'DocumentListReducer',
  DOCUMENT_EDIT_REDUCER = 'DocumentEditReducer',
  VIEW_TASK_DETAIL = 'ViewTaskReducer',
  VIEW_USER_INFO = 'ViewUserInfoReducer',
  FCM_REDUCER = 'FCMReducer',
  PRODUCT_TAG_REDUCER = 'ProductTagReducer',
  CUSTOMER_TAG_REDUCER = 'CustomerTagReducer',
  POINT_OF_INTERESTS_REDUCER = 'PointOfInterestsReducer',
  POINT_OF_INTEREST_CATEGORY_REDUCER = 'PointOfInterestCategoryReducer',
  REPORTING_REDUCER = 'ReportingReducer',
  DASHBOARD_REDUCER = 'DashboardReducer',
  SEND_MAIL_REDUCER = 'SendMailReducer',
}
